import { useState } from "react";
import { contact } from "@/mocks/gossip";
import { scrollToId } from "@/lib/scroll";

const sectionLinks = [
  { id: "hero", label: "首屏头条" },
  { id: "headlines", label: "头条首发" },
  { id: "exclusive", label: "独家抢先" },
  { id: "flash", label: "速递快讯" },
  { id: "hot", label: "热点榜单" },
  { id: "category", label: "吃瓜分类" },
  { id: "faq", label: "吃瓜指南" },
  { id: "about", label: "关于我们" },
];

const catNames = ["影视热映", "综艺现场", "乐坛声浪", "主播红人", "品牌热议", "行业观察"];

export default function Footer() {
  const [year] = useState(new Date().getFullYear());

  return (
    <footer className="bg-brand-800 text-brand-100">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-8 px-4 py-12 md:px-6 md:grid-cols-2 lg:grid-cols-4">
        {/* 品牌 */}
        <div className="lg:pr-4">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500 font-heading text-lg font-black text-white">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-[19px] font-black text-white">{contact.brand}</span>
              <span className="mt-0.5 text-[11px] tracking-[0.18em] text-gold-200">速递 · 快讯 · 独家</span>
            </span>
          </div>
          <p className="mt-4 text-[13px] leading-relaxed text-brand-200/90">{contact.slogan}</p>
          <p className="mt-2 text-[12px] leading-relaxed text-brand-200/70">{contact.email}</p>
          <div className="mt-4 flex items-center gap-2">
            {[
              { icon: "ri-weibo-line", label: "微博" },
              { icon: "ri-bilibili-line", label: "B站" },
              { icon: "ri-douban-line", label: "豆瓣" },
              { icon: "ri-tiktok-line", label: "抖音" },
            ].map((s) => (
              <a
                key={s.label}
                href="#newsletter"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("newsletter");
                }}
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10 text-[16px] text-brand-100 transition-colors hover:bg-brand-500 hover:text-white"
                aria-label={s.label}
              >
                <i className={s.icon} />
              </a>
            ))}
          </div>
        </div>

        {/* 内容导航 */}
        <div>
          <h4 className="text-[14px] font-bold text-white">内容版块</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {sectionLinks.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToId(l.id);
                  }}
                  className="text-[13px] text-brand-200/90 transition-colors hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* 吃瓜分类 */}
        <div>
          <h4 className="text-[14px] font-bold text-white">娱乐吃瓜分类</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {catNames.map((c) => (
              <li key={c}>
                <a
                  href="#category"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToId("category");
                  }}
                  className="text-[13px] text-brand-200/90 transition-colors hover:text-white"
                >
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* 订阅提示 */}
        <div>
          <h4 className="text-[14px] font-bold text-white">每日速递</h4>
          <p className="mt-4 text-[13px] leading-relaxed text-brand-200/90">
            早高峰 + 晚间两封快讯，聚合当日独家、热榜与分类要点。刷新越快、料越足，一线新瓜不错过。
          </p>
          <button
            onClick={() => scrollToId("newsletter")}
            className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-lg bg-gold-500 px-4 py-2 text-[13px] font-semibold text-brand-900 transition-colors hover:bg-gold-400"
          >
            <i className="ri-mail-send-line" /> 免费订阅
          </button>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-2 px-4 py-5 text-center sm:flex-row md:px-6">
          <p className="text-[12px] text-brand-200/70">
            © {year} {contact.brand} 版权所有 · 只讲核实过的瓜
          </p>
          <p className="inline-flex items-center gap-1.5 text-[12px] text-brand-200/70">
            <i className="ri-verified-badge-fill text-gold-300" />
            理性吃瓜 · 拒绝造谣与网暴 · 先问真假再论对错
          </p>
        </div>
      </div>
    </footer>
  );
}